import services from "./services"
export default {
mixins:[services],
data() {
    return {
        loading: false,
        lists:[],//表格内容列表{"CourseId":3,"CourseName":"英语上","SubjectId":1,"SubjectName":"英语","VolumeType":1,"VolumeTypeName":"上册"}
        pageIndex: 1,
        pageSize: 10,
        totalSize: '',
        pageSizes: [10, 20, 50],
        sels: [],//列表选中
        searchVisiable:"",
        form:{
            IMEI:"",
            HardType:"",
            BindTimeStart:"",
            BindTimeEnd:""
        },
        EquipType:[{id:'-1',text:'全部'},{id:'0',text:'电视'},{id:'1',text:'摄像头'},{id:'2',text:'广告机'}]
    }
},
methods: {
    handleSizeChange: function (val) {
        this.pageSize = val;
        this.getList();
    },//分页选定行
    handleCurrentChange: function (val) {
        this.pageIndex = val;
        this.getList();
    },//分页监听dd页面
    toggleSearch() {
        this.searchVisiable = !this.searchVisiable;
    },
    reset(){
       this.form={
            IMEI:"",
            HardType:"",
            BindTimeStart:"",
            BindTimeEnd:""
        };
        this.pageIndex=1;
        this.getList();
    }
},
computed:{
    sysSid:function(){
        return this.$store.state.sysSid;
    },
    sysSession:function(){
        return this.$store.state.sysSession;
    },
    arrowClass () {
        return {
            'el-icon-arrow-down': !this.searchVisiable,
            'el-icon-arrow-up': this.searchVisiable
        };
    },
},
//组件初始化
created() {
    this.getList();   
}
}



// WEBPACK FOOTER //
// ./src/pages/school/SchoolEquipment/vm.js